import { render, staticRenderFns } from "./stopSession.vue?vue&type=template&id=490e341d&"
import script from "./stopSession.vue?vue&type=script&lang=js&"
export * from "./stopSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports